export enum QuoteSortType {
  ALL = "ALL", // 전체 (최신 등록순)
  INVOICE_PROCEED = "INVOICE_PROCEED", // 발주 진행 순
  PRICE_DESC = "PRICE_DESC", // 금액 높은순
  PRICE_ASC = "PRICE_ASC", // 금액 낮은순
}

export const quoteSortTypeDisplayNames = {
  [QuoteSortType.ALL]: "전체 (최신 등록순)",
  [QuoteSortType.INVOICE_PROCEED]: "발주 진행 순",
  [QuoteSortType.PRICE_DESC]: "금액 높은순",
  [QuoteSortType.PRICE_ASC]: "금액 낮은순",
};
